import { styled } from '@mui/material/styles';

import { device } from 'src/constants/muiSize';

export const Container = styled('div')(({ theme }) => ({
  width: '100%',

  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  justifyContent: 'space-between',

  padding: '2.4rem 13rem 4rem',

  [`@media ${device.laptop}`]: {
    padding: '3rem',
  },

  backgroundColor: theme.colors.base07,
}));

export const Base02TextContainer = styled('div')(({ theme }) => ({
  color: theme.colors.base02,

  marginTop: '1.1rem',
}));

export const DescriptionContainer = styled('div')(({ theme }) => ({
  width: '100%',
  whiteSpace: 'pre-wrap',

  [`@media ${device.laptop}`]: {
    width: '90%',
  },
  color: theme.colors.base03,

  marginTop: '2rem',
}));

export const MediaContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',

  color: theme.colors.base02,

  columnGap: '4rem',

  marginTop: '4rem',

  [`@media ${device.laptop}`]: {
    flexDirection: 'column',

    rowGap: '1.6rem',

    marginTop: '3rem',
  },
}));

export const MediaItemButton = styled('button')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',

  columnGap: '0.6rem',

  backgroundColor: 'transparent',
  border: 'none',

  padding: '0',

  color: theme.colors.base02,

  '&:hover': {
    opacity: '0.8',
  },

  cursor: 'pointer',

  [`@media ${device.laptop}`]: {
    width: '100%',
  },
}));
